<ng-container *ngIf="visibility$ | async">
  <button
    (click)="openModal($event)"
    class="nordic-blue-900-text text-icon-primary ps-large-x ps-xsmall-y bold font-body-1 nordic-blue-50-bg surface-secondary rounded-top-medium font-body-medium"
  >
    {{ 'feedback.buttonTitle' | finLocalization }}
  </button>

  <fin-qualtrics
    *ngIf="feedbackSurvey$ | async as survey"
    [survey]="survey"
    [open]="openSurveyTrigger$ | async"
    (openChange)="openSurveyTrigger$.next($event)"
  />
</ng-container>
